// HeroContainer.tsx
import { Box, BoxProps } from '@mui/material';

interface HeroContainerProps extends BoxProps {
  backgroundImage?: string;
  backgroundColor?: string;
  height?: string | number;
  width?: string | number;
  sx?: Record<string, any>;
  children?: any;
}

const HeroContainer = ({ backgroundImage, backgroundColor, height = '100vh', width = '100%', sx: rest, children }: HeroContainerProps) => {
  return (
    <Box
      sx={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
        bgcolor: backgroundColor || 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        height,
        width,
        ...rest,
      }}
    >
      {children}
    </Box>
  );
};

export default HeroContainer;
